<template>
	<div style="min-height:250px">
		<div class="fs4 fw7 mb1 lh125">
			{{ $t("benefit_claims") }}
		</div>
		<core-form-input
			v-if="internalBenefitClaims.length > 0 || policyId"
			:placeholder="$t('search_benefit_name')"
			componentName="j-base-multi-select-with-flexible-value"
			name="benefit_claims"
			nameKey="name"
			valueKey="typeId"
			:allowMultiselect="true"
			:allowLocalSearch="true"
			v-model="internalBenefitClaims"
			:options="benefitOptions"
		/>
		<j-button
			type="tertiary"
			size="small"
			@click="isCreateNewBenefitVisible = !isCreateNewBenefitVisible"
			class="mt1"
		>
			<crm-icon name="add" size="small" color="c2" />
			{{ $t("create_new_benefit") }}
		</j-button>

		<!-- Create new benefit -->
		<div class="mt6 bg5 b1 bc7 r2" v-if="isCreateNewBenefitVisible">
			<div class="p4 fs5 pb2 fw7">{{ $t("create_new_benefit") }}</div>
			<create-new-benefit
				@addCustomBenefit="addCustomBenefit"
				@hide="isCreateNewBenefitVisible = false"
			/>
		</div>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon/"
import CoreModal from "@/modules/core/components/CoreModal"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import CoreSelectCurrency from "@/modules/core/components/CoreSelectCurrency"
import CreateNewBenefit from "../components/CreateNewBenefit"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import JList from "@/components/JList"
import ScalarValueInput from "../components/ScalarValueInput"
import { unCamelCase } from "@/utils/"
import api from "../api"

export default {
	components: {
		CreateNewBenefit,
		CoreModal,
		CoreFormInput,
		CrmIcon,
		JButton,
		JCard,
		JList,
		ScalarValueInput,
		CoreSelectCurrency
	},

	props: {
		policyId: {
			type: String
		},
		benefitClaims: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			internalBenefitClaims: null,
			benefitOptions: [],
			isCreateNewBenefitVisible: false
		}
	},

	methods: {
		addCustomBenefit(benefit) {
			this.internalBenefitClaims.push({
				...benefit
			})
			this.isCreateNewBenefitVisible = false
		},

		async fetchBenefits() {
			if (!this.policyId) return
			this.benefitOptions = [] // Reset benefit options

			// Fetch
			const where = { id: this.policyId }
			const res = await api.findPolicyDetails({ where })
			const benefits =
				res?.data?.policies?.list?.[0]?.acceptedOffer?.product?.benefits || []
			const claimBalance = res?.data?.policies?.list?.[0]?.claimBalance || []

			// Filter out benefits - show only unique ones
			const uniq = [...new Set(benefits.map(item => item.typeId))]
			const uniqueBenefits = uniq.reduce((acc, c) => {
				return [...acc, benefits.find(({ typeId }) => c === typeId)]
			}, [])

			this.benefitOptions = uniqueBenefits
		}
	},

	watch: {
		policyId: {
			handler() {
				this.fetchBenefits()
			},
			immediate: true
		},

		/**
		 * When benefitClaims prop changes, populate internalBenefitClaims
		 */
		benefitClaims: {
			handler(newValue, oldValue) {
				this.internalBenefitClaims = newValue
			},
			immediate: true,
			deep: true
		},

		/**
		 * When internalBenefitClaims changes, emit up so that state in the parnet can be updated
		 */
		internalBenefitClaims: {
			handler(newValue, oldValue) {
				this.$emit("input", newValue)
			},
			deep: true,
			immediate: false
		}
	}
}
</script>